import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShareArrowRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.75 7.5c.416 0 .75-.334.75-.75V4.707L16.294 8.5 12.5 12.294V10.25a.75.75 0 0 0-.75-.75H8a4.5 4.5 0 0 0-4.337 3.297A5 5 0 0 1 3.5 11.5a4 4 0 0 1 4-4zM11 11v2.5a1.004 1.004 0 0 0 1.71.71l5-5c.39-.391.39-1.025 0-1.416l-5-5a1 1 0 0 0-1.091-.216A1 1 0 0 0 11 3.5V6H7.5A5.5 5.5 0 0 0 2 11.5c0 2.438 1.206 3.944 2.147 4.753.128.11.253.207.365.291q.15.11.279.194c.14.093.259.16.337.203s.166.06.253.06c.34 0 .616-.279.616-.616 0-.213-.113-.413-.26-.566l-.043-.044a2 2 0 0 1-.24-.268 2 2 0 0 1-.157-.247C5.13 14.957 5 14.544 5 14.003a3 3 0 0 1 3-3h3z" })
});
export default SvgShareArrowRegularIcon;
